import React, { useState } from 'react';
import { Box } from '@mui/material';
import { generateTestId } from 'app/functions';
import { colors, spacing } from 'common/theme';
import { PopupCloseButton } from './PopupCloseButton';
import { EligiblesBadge } from './EligiblesBadge';
import { EligiblesContentColumn } from './EligiblesContentColumn';
import { EligiblesPurchasedBenefits } from './EligiblesPurchasedBenefits';

const POPUP_SHADOW = '0 4px 24px rgba(45, 86, 199, 0.16)';

export const HotYoterEligiblesPopupPanel = ({
    content,
    purchasedBenefits = [],
    hideActionLabel = false,
    typography,
    layout,
    onClose,
    onActionPress,
    testID = 'hot-yoter-eligibles-popup-panel',
}) => {
    const [purchasedExpanded, setPurchasedExpanded] = useState(false);
    const hasPurchasedBenefits = purchasedBenefits.length > 0;
    const showInlineViewAction = hasPurchasedBenefits;

    return (
        <Box
            dir="rtl"
            testId={testID}
            sx={{
                position: 'relative',
                backgroundColor: colors.system.surface.modal,
                boxShadow: POPUP_SHADOW,
                pointerEvents: 'auto',
                ...layout.panelSx,
            }}
        >
            <PopupCloseButton
                onClose={onClose}
                iconSize={layout.closeIconSize}
                testID={generateTestId(testID, 'close')}
            />
            <Box
                testId={generateTestId(testID, 'body')}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: hasPurchasedBenefits ? `${spacing.sm}px` : 0,
                    pr: layout.bodySx.pr,
                    pl: layout.bodySx.pl,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: layout.bodySx.gap,
                        alignItems: 'center',
                        minHeight: hasPurchasedBenefits ? 'auto' : layout.bodySx.minHeight,
                    }}
                >
                    <EligiblesBadge
                        count={content.badgeCount}
                        circleSize={layout.badgeCircleSize}
                        testID={generateTestId(testID, 'badge')}
                    />
                    <EligiblesContentColumn
                        content={content}
                        hideActionLabel={hideActionLabel}
                        typography={typography}
                        chevronWidth={layout.chevronWidth}
                        onActionPress={onActionPress}
                        showViewAction={showInlineViewAction}
                        viewActionExpanded={purchasedExpanded}
                        onViewActionToggle={() => setPurchasedExpanded((current) => !current)}
                        testID={generateTestId(testID, 'content')}
                    />
                </Box>
                <EligiblesPurchasedBenefits
                    purchasedBenefits={purchasedBenefits}
                    expanded={purchasedExpanded}
                    testID={generateTestId(testID, 'purchased')}
                />
            </Box>
        </Box>
    );
};
